import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
    name: "user",
    initialState: {
        currentUser: null,
        isFetching: false,
        error: null
    },
    reducers: {
        userStart: (state) => {
            state.isFetching = true
        },
        userFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        loginSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.currentUser = action.payload
        },
        loginFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
            state.currentUser = null
        },
        logoutSuccess: (state) => {
            state.isFetching = false
            state.error = null
            state.currentUser = null
        },
        updateUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.currentUser = action.payload.user
        },
        createUserSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
        }
    }
})

export const { userStart, userFailure, loginSuccess, loginFailure, logoutSuccess, updateUserSuccess, createUserSuccess } = userSlice.actions
export default userSlice.reducer